import { combineReducers } from 'redux';

const routeReducer = (state = { location: null, action: null }, action) => {
  switch (action.type) {
    case 'ROUTE_CHANGED':
      return {
        ...state,
        location: action.payload.location,
        action: action.payload.action,
      };
    default:
      return state;
  }
};

export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    router: routeReducer,
    ...injectedReducers,
  });
}